export default __webpack_public_path__ + "static/severinsen-c0ee1dc2270737baf92de6acb135850e.jpg";